<template>
  <modal
    class="createTargetModal"
    name="setMaximumCashAmount"
    transition="pop-out"
    :width="650"
    :height="300"
    @opened="opened"
    @closed="closed"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="50" height="60"
      /></span>
      <h4>{{ $t("text.maxCashAmtModal.title") }}</h4>
    </div>

    <div>
      <div class="input__group__block mt-4" style="margin: 0 auto; width: 50%">
        <label class="required"> {{ $t("text.form.amount") }} </label>
        <div class="input__block" ref="target_input_div">
          <input
            style="padding: 20px; width: 100%"
            type="number"
            :placeholder="$t('text.maxCashAmtModal.inputAmount')"
            v-model="amount"
          />
        </div>
      </div>
      <div class="text-center py-3 mt-3">
        <button
          class="sales_target_btn text-center"
          @click="setAmount()"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          <span>{{ $t("text.maxCashAmtModal.updateAmt") }}</span>
        </button>
        <img
          src="@/assets/img/git_loader.gif"
          style="display: none"
          width="35px"
          class="ml-3 loader"
        />
      </div>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;

import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "setMaximumCashAmount",
  props: ["branchId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      amount: null,
      isButtonDisabled: false,
      currentAmount: null,
    };
  },
  mounted() {},
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    setAmount() {
      if (!this.amount) {
        this.$toast.open({
          message: this.$t("text. maxCashAmtModal.amtErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.amount == this.currentAmount) {
        this.$toast.open({
          message: this.$t("text. maxCashAmtModal.inputDiffErr"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.amount < 0) {
        this.$toast.open({
          message: this.$t("text. maxCashAmtModal.inputGreaterPrev"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let data = {
        cashInsuranceRatio: parseFloat(this.amount),
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Branch/UpdateCashInsuranceRatio/${this.branchId}`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text. maxCashAmtModal.successfullyUpdatedCIR"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.amount = null;
          this.$modal.hide("setMaximumCashAmount");
        })
        .catch((e) => {
          this.$toast.open({
            message: e.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    opened() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/CashInsuranceRatio/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.amount = response.data;
          this.currentAmount = response.data;
        })
        .catch((error) => {});
    },
    closed() {
      this.amount = null;
    },
  },
};
</script>
